import { rem } from '../themeUtils';

/**
 * The dark bubble BitkitTooltip and BitkitToggletip share, so a hint looks the same whether it opens
 * on hover (a tooltip, text only) or on click (a toggletip, which can hold a link or a button).
 */
export const base = {
  positioner: {
    fontFamily: 'body',
  },
  content: {
    '--tooltip-bg': 'colors.background/contrast',
    backgroundColor: 'var(--tooltip-bg)',
    // Without a cap a tooltip grows to the width of its text, so a long one runs to the edge of
    // the viewport. Every component that renders a tooltip therefore has to set this, and the one
    // that forgot -- BitkitLabelTooltip -- had no cap at all. It belongs to the tooltip, not to
    // each caller. BitkitOverflowTooltip overrides it: it exists to show text that was truncated,
    // so it is allowed to be wider.
    maxWidth: rem(320),
    color: 'text/on-contrast',
    boxShadow: 'elevation/tooltip',
    zIndex: 'tooltip',
    transformOrigin: 'var(--transform-origin)',
    _open: {
      animationStyle: 'scale-fade-in',
      animationDuration: 'fast',
    },
    _closed: {
      animationStyle: 'scale-fade-out',
      animationDuration: 'fast',
    },
  },
  arrow: {
    '--arrow-size': rem(8),
    '--arrow-background': 'var(--tooltip-bg)',
  },
  arrowTip: {
    borderTopWidth: '1',
    borderInlineStartWidth: '1',
    borderColor: 'var(--tooltip-bg)',
  },
} as const;

export const variants = {
  variant: {
    dark: {
      content: {
        '--tooltip-bg': 'colors.background/contrast',
        color: 'text/on-contrast',
      },
    },
    light: {
      content: {
        '--tooltip-bg': 'colors.background/tertiary',
        color: 'text/primary',
      },
    },
  },
  paddingSize: {
    sm: {
      content: {
        paddingInline: '8',
        paddingBlock: '4',
        borderRadius: '4',
      },
    },
    md: {
      content: {
        paddingInline: '12',
        paddingBlock: '8',
        borderRadius: '8',
      },
    },
    lg: {
      content: {
        padding: '16',
        borderRadius: '8',
      },
    },
  },
  textStyle: {
    'sm/regular': {
      content: {
        textStyle: 'body/sm/regular',
      },
    },
    'sm/semibold': {
      content: {
        textStyle: 'body/sm/semibold',
      },
    },
    'md/regular': {
      content: {
        textStyle: 'body/md/regular',
      },
    },
  },
} as const;
